"use client";
import { createCustomContext as t } from "../../utils/context.js";
const [e, r] = t({
  name: "ButtonGroupContext",
  strict: !1
});
export {
  e as ButtonGroupProvider,
  r as useButtonGroupContext
};
